import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=0ac04a7e&scoped=true&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"
import style0 from "./widget.vue?vue&type=style&index=0&id=0ac04a7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac04a7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ac04a7e')) {
      api.createRecord('0ac04a7e', component.options)
    } else {
      api.reload('0ac04a7e', component.options)
    }
    module.hot.accept("./widget.vue?vue&type=template&id=0ac04a7e&scoped=true&", function () {
      api.rerender('0ac04a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/compose/widget.vue"
export default component.exports